
export default {
  inheritAttrs: false,
  props: {
    links: {
      type: Array,
      default: null
    },
    mode: {
      type: String,
      default: 'horizontal'
    },
    width: {
      type: [String, Object],
      default: null
    },
    textColor: {
      type: String,
      default: 'black'
    },
    activeTextColor: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    menuItems() {
      return this.links.reduce((links, link) => {
        const path  = link.route ? this.$pagePath(link.route) : link.href
        const route = {
          ...link,
          label: link.translate === false ? link.label : this.$t(link.label),
          href: path,
          value: path,
          route: path,
          children: link.children,
        }

        links.push(route)
        return links
      }, [])
    },
    activeIndex() {
      let path = this.$route.path

      const hasIndex = this.menuItems.find((item) => {
        return item.index == path
      })

      if (hasIndex) {
        return path
      }

      Object.values(this.$route.params).forEach(param => {
        path = path.replace(`/${param}`, '')
      })

      return path
    }
  }
}
